export default "__VITE_ASSET__DSuekEUJ__"